import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import oitsActionCreators from '../../store/oits/action-creators/index';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import OitDetail from './OitDetail';
import OitIndex from './OitIndex';
import OitTasksIndex from './OitTasksIndex';
import ftosActionCreators from "../../store/ftos/action-creators";

class OitContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.loadOitsContainer();

    if(this.props.userContext.hasScope(['ftoc', 'sup'])) {
      this.props.fetchFtos();
    }
  }

  componentWillUnmount() {
    this.props.unmountOitsContainer();
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.props.isLoading}>
        <div>
          <Route component={OitIndex} exact path="/oits" />
          <Route component={OitTasksIndex} path="/oits/:oitGuid/tasks" />
          <Route component={OitDetail} path="/oits/:oitGuid/training-program" />
        </div>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.oits.isLoading.length > 0,
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
    unmountOitsContainer: () => {
      return dispatch(oitsActionCreators.unmountOitsContainer());
    },
    fetchFtos: () => {
      return dispatch(ftosActionCreators.fetchFtos())
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OitContainer));
